import React from 'react';

const AppliedTag = ({ appliedDate=null,isFromJobDetails=false }:any) => {
    return (
        <div>
            <div className="flex w-full justify-end">

                <div className="flex items-center gap-2 ml-2">
                    <span className="flex items-center justify-center w-5 h-5 rounded-full bg-green-600">
                        <svg
                            className="w-3 h-3 text-white"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="3"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 13l4 4L19 7"
                            />
                        </svg>
                    </span>
                    <span className="text-green-600 flex text-sm font-medium">
                       {isFromJobDetails&&appliedDate?"You applied to this posting on ": appliedDate? "Applied on":"Applied"}
                          {appliedDate &&  <span className=' ml-1 mt-[2px] flex items-end text-[12px]'> {appliedDate}</span>}
                    </span>

                    
                </div>

            </div>
        </div>
    );
}

export default AppliedTag;
